export default __webpack_public_path__ + "static/media/my-quests.8499723a.png";